import { normalize } from "styled-normalize";
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  ${"" /* Write your global styles below */}
  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    padding: 0;
    background-color: rgba(250, 250, 250, 1);
    color: rgba(20, 20, 20, 1);
    font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 16px;
    line-height: 1.5;
  }

  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
    line-height: 1.25;
    text-align: center;
    font-family: Roboto, -apple-system, sans-serif;
    font-weight: 800;
    color: #333;
  }

  button {
    background-color: rgba(72, 13, 114, 0.9);
    color: rgba(230, 230, 230, 1);
    border: none;
    cursor: pointer;
    padding: 8px 9px;

    &:hover {
      background-color: rgba(102, 33, 144, 1);
      color: #fff;
      cursor: pointer;
    }
  }
`;
